<template>
	<WalletMultiButton
		:openOnboardingUrls="false"
		:connecting="connecting"
		@copy="onCopy"
		@error="onWalletError"
		@connect="onConnect"
		@disconnect="onDisconnect"
		:wallets="custom_wallets"
		:auto-connect="false"
		:featured="3"
		dark
	></WalletMultiButton>
</template>

<script>
import {useWalletStore} from "@/pinia";
import {WalletMultiButton} from "@alphabatem/vue2-wallet-adapter";
import {mapStores} from 'pinia'
import {useAlertStore} from "@/pinia/alertStore";


export default {
	name: "MultiWallet",
	components: {
		WalletMultiButton,
	},
	props: {
		button_text: {
			type: String,
			default: function () {
				return "Connect Wallet";
			},
		},
	},
	data() {
		return {
			key: 0,
			attempts: 0,
			connecting: false,
			custom_wallets: [
				//
			],
		};
	},
	watch: {
		"walletStore.wallet"() {
			console.log("MultiWallet::Force update");
			this.$forceUpdate();
		},
		"$store.state.wallet.wallet"() {
			console.log("MultiWallet::Force update");
			this.$forceUpdate();
		},
	},
	computed: {
		...mapStores(useWalletStore, useAlertStore)
	},
	methods: {
		onDisconnect() {
			this.AlertStore.error("Wallet disconnected")
			this.$store.dispatch("wallet/walletDisconnected");
			localStorage.removeItem("walletName");
			this.walletStore.clearWallet()
		},

		onCopy(addr) {
			this.AlertStore?.success("Address copied to clipboard")
		},

		onWalletError(e) {
			this.AlertStore.error("Wallet Error")
		},
		async onConnect(wallet) {
			if (!wallet) return;

			console.log("onConnect Wallet", wallet, !!wallet.adapter.connect);

			await wallet.adapter.connect().catch(e => {
				console.error("onConnect::connect err", e)
			})
			if (!wallet.adapter.connected) {
				console.log("Failed to connect to wallet")
				this.AlertStore.error("Failed to connect to wallet")
				return
			}

			this.$emit("adapter", wallet.adapter)

			if (!this.walletStore.isConnected || !this.$store.state.wallet.connected) {
				console.log("Settings wallet on walletStore")
				this.walletStore.setWallet(wallet.adapter)
				this.AlertStore?.success("Wallet connected!", wallet.adapter?.publicKey)


				this.$store.commit("wallet/set_wallet", wallet.adapter);
				this.$store.commit(
					"wallet/set_wallet_address",
					wallet.adapter?.publicKey
				);
				this.$store.dispatch("wallet/walletConnected");
				this.$store.dispatch("cache/refreshUserBalance");
			}

			this.$emit("connected", true);
			window.gtag("event", "wallet_connect");
		},
	},
	beforeMount() {
		// if (!this.walletStore.isBotWallet) {
		// 	this.custom_wallets.push(new FluxBotWalletAdapter())
		// }
	}
};
</script>

<style>
.swv-dropdown-list li {
	font-size: 0.9rem !important;
}
</style>
